import { Box, Dialog as MuiDialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';

import { useWidth } from '../../hooks/use-width';

import theme from '../../config/theme';
import constants from '../../config/constants';

type PropsTypes = {
  open: boolean;
  renderContent: React.ReactNode;
  handleClose?: () => void;
  overflow?: string;
  disableRenderClose?: boolean;
  overflowBox?: boolean;
};

export default function Dialog(props: PropsTypes) {
  const { open, renderContent, handleClose, overflow, overflowBox } = props;

  const currentBreakpoint = useWidth();

  return (
    <>
      <MuiDialog
        aria-describedby="alert-dialog-slide-description"
        keepMounted={false}
        maxWidth={currentBreakpoint}
        onClose={handleClose}
        open={open}
        sx={{
          '& .MuiDialog-paperScrollPaper': {
            backgroundColor: 'transparent',
            overflowY: 'inherit',
            justifyContent: 'center',
            display: 'flex',
            boxShadow: 'none',
            [theme.breakpoints.down('lg')]: {
              alignItems: 'center',
            },
          },
          '& .MuiDialog-container > .MuiPaper-root': {
            '&>div': {
              overflowY: overflowBox ? 'auto' : 'inherit',
              overflow: 'hidden',
              '&>div': {
                overflowY: overflowBox ? 'auto' : 'inherit',
              },
            },
            maxHeight: '100%',
          },
          backdropFilter: constants.BLUR_STYLE.filter,
          backgroundColor: 'transparent',
          zIndex: (theme) => theme.zIndex.tooltip,
        }}
      >
        <Box display={'grid'} overflow={overflow}>
          {renderContent}
        </Box>
      </MuiDialog>
    </>
  );
}
